import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { clsx } from 'clsx';

import { Icon, IconComponent } from '../../icon';

export type EmptyStateContentSize = 'sm' | 'auto';

@Component({
  selector: 'sb-empty-state',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, NgClass],
  templateUrl: './empty-state.component.html',
})
export class EmptyStateComponent {
  title = input<string | SafeHtml | undefined>(undefined);

  description = input.required<string>();

  icon = input.required<Icon>();

  richIcon = input(false);

  contentSize = input<EmptyStateContentSize>('sm');

  @HostBinding('class')
  classNames = clsx('flex flex-col items-center justify-center');
}
